const o = 760, t = "editor-id";
export {
  o as MAX_EDITOR_WIDTH,
  t as editorId
};
